import styled from 'styled-components';
import flex from './../../styles/flex';
import { applyTheme, getThemeColor, hover, when } from './../../styles/mixins';
import { breakpoints, isHorizontal, smaller, smallerHeight } from './../../styles/responsive';

//components
import Icon from './../../icons/Icon';

export const StackImage = styled(Icon)(
  {
    ...flex.centerVertical,
    marginRight: 0,
    width: 'clamp(30px, 2.8vw, 36px)',
    height: 'clamp(30px, 2.8vw, 36px)',
    position: 'relative',
    top: 0,
    display: 'block',
    transformOrigin: 'center center'
  },
  ({ theme }) => ({
    color: theme.name === 'dark' ? '#ffffff' : '#111111',
    fill: 'currentColor',
    stroke: 'currentColor',
    '& path, & g, & rect, & circle, & polygon, & line, & polyline': {
      fill: 'currentColor',
      stroke: 'currentColor'
    }
  })
);

export const Button = styled.div({
  ...flex.horizontal,
  ...flex.centerHorizontal,
  ...flex.centerVertical,
  width: 'clamp(52px, 5vw, 64px)',
  height: 'clamp(52px, 5vw, 64px)',
  minWidth: 'clamp(52px, 5vw, 64px)',
  borderRadius: 12,
  border: '1px solid rgba(255,255,255,0.18)',
  background: 'rgba(255,255,255,0.04)',
  boxShadow: '0 6px 16px rgba(0,0,0,0.18)',
  padding: 0,
  lineHeight: 0
});

export const Content = styled.div({
  ...flex.centerVertical,
  ...flex.centerHorizontal,
  [isHorizontal]: {
    fontSize: 20,
    //lineHeight: '30px'
  }
});

export const Stacker = styled.div({
  ...flex.centerVertical,
  ...flex.centerHorizontal,
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  padding: '8px 12px',
  [smaller(1520)]: {
    fontSize: 20
  },
  [smaller(1150)]: {
    fontSize: 20
  },
  [smaller(980)]: {
    fontSize: 20
  },
  [smaller(breakpoints.medium)]: {
    fontSize: 22,
    maxWidth: '100%'
    // padding: "200px"
  },
  [isHorizontal]: {
    flexDirection: 'column',
    ...flex.centerVertical,
    maxWidth: 400
  }
});

export const ServicesGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '10px 18px',
  width: '100%',
  maxWidth: 1200,
  alignItems: 'stretch',
  [smaller(980)]: {
    gridTemplateColumns: '1fr'
  }
});

export const MobileWeb = styled.div({
  ...flex.horizontal,
  //...flex.spaceAround,
  // ...zIndexFor(ELEMENTS.CONTENT),
  marginTop: 'auto',
  marginBottom: 'auto',
  padding: "1rem",
  // marginLeft: 50,
  // padding: "0rem 7rem 0rem 8rem",
  [isHorizontal]: {
    flexDirection: 'column',
    ...flex.centerVertical
  }
});

export const DesignQuality = styled.div({
  ...flex.horizontal,
  //...flex.spaceAround,
  // ...zIndexFor(ELEMENTS.CONTENT),
  marginTop: 'auto',
  marginBottom: 'auto',
  padding: "1rem",
  // marginLeft: 50,
  // padding: "0rem 7rem 0rem 8rem",
  [isHorizontal]: {
    flexDirection: 'column',
    ...flex.centerVertical
  }
});

export const ProgLang = styled.div({
  ...flex.horizontal,
  ...flex.spaceAround,
  width: '85%',
  // ...zIndexFor(ELEMENTS.CONTENT),
  margin: "0 auto",
  marginTop: 'auto',
  // marginLeft: 50,
  // padding: "0rem 7rem 0rem 8rem",
  marginBottom: 'auto',
  // [isHorizontal]: {
  //   flexDirection: 'column',
  //   ...flex.centerVertical
  // }
});

export const Window = styled.div({
  ...flex.horizontal,
  alignItems: 'flex-start',
  width: '100%',
  // ...zIndexFor(ELEMENTS.CONTENT),
  marginTop: 0,
  marginBottom: 0,
  [isHorizontal]: {
    flexDirection: 'column',
    ...flex.centerVertical
  }
});

export const Slider = styled.div({
  // ...flex.horizontal,
  //...flex.centerVertical,
  //...flex.centerHorizontal,
  //...flex.spaceBetween,
  //marginLeft: window.innerWidth/7,
  maxWidth: "250px"
  //  ...zIndexFor(ELEMENTS.CONTENT),
});
